export default {
  isMobile: function () {
    return navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js